import React from 'react';
import { Y_AXIS_UNIT } from 'recommendationsNew/consts';
import { BASE_PROPERTIES, COST_PROPERTIES, EC2_PROPERTIES, RDS_PROPERTIES } from '../../recommendationPropertyUtils';
import RecommendationPreferences from '../../recommendationGenericComponents/recommendationPreferences';
import RecommendationDetails from '../../recommendationGenericComponents/recommendationDetails';
import RecommendationDetailsLayout from '../../recommendationDetailsLayout';
import RecommendationCommand, { COMMAND_TYPES } from '../../recommendationGenericComponents/recommendationCommand';
import RecommendationInsideLook from '../../recommendationGenericComponents/recommendationInsideLook';
import RecommendationChartData, {
  CHART_TYPES,
} from '../../recommendationGenericComponents/recommendationChart/recommendationChartData';

const Ec2Idle = ({ recommendation }) => {
  const properties = {
    ...BASE_PROPERTIES,
    ...COST_PROPERTIES,
    ...RDS_PROPERTIES,
    ...EC2_PROPERTIES,
  };

  const chartsData = [
    {
      chartType: CHART_TYPES.GENERIC,
      chartTitle: 'Network Performance',
      yAxisLabel: 'Network I/O (MB)',
      yAxisUnit: Y_AXIS_UNIT.BYTE,
      linesList: [
        {
          id: 'networkOut',
          label: 'Network Out',
          data: recommendation.recData?.network_out_statistics_usage,
        },
        {
          id: 'networkIn',
          label: 'Network In',
          data: recommendation.recData?.network_in_statistics_usage,
        },
      ],
      referenceLines: [
        {
          yAxisValue: recommendation?.recData?.max_network,
          label: `Low Network Performance Benchmark ${recommendation?.recData?.max_network} MB`,
        },
      ],
    },
    {
      chartType: CHART_TYPES.GENERIC,
      chartTitle: 'CPU Performance',
      yAxisLabel: 'CPU',
      yAxisUnit: Y_AXIS_UNIT.PERCENT,
      linesList: [
        {
          id: 'cpu',
          label: 'CPU',
          data: recommendation.recData?.cpu_util_statistics_usage,
        },
      ],
      referenceLines: [
        {
          yAxisValue: recommendation?.recData?.max_cpu_util,
          label: `Max CPU Utilization Benchmark ${recommendation?.recData?.max_cpu_util}%`,
        },
      ],
    },
  ];

  const description =
    'This EC2 instance has a low CPU, the daily average CPU is less than 1% and network in/out is lower than 10MB';

  const insideLookComponent = <RecommendationInsideLook description={description} recData={recommendation?.recData} />;

  const detailsComponent = (
    <RecommendationDetails recommendationProperties={properties} recommendation={recommendation} />
  );

  const commandsList = [
    {
      type: COMMAND_TYPES.CLI,
      instructions: [
        {
          actionCommand: `aws ec2 terminate-instances --instance-ids ${recommendation.resourceId}`,
        },
      ],
    },
  ];

  const commandComponent = <RecommendationCommand commandsList={commandsList} />;

  const preferencesComponent = <RecommendationPreferences recommendationType={recommendation.typeId} />;

  const chartsComponent = <RecommendationChartData chartsData={chartsData} />;

  return (
    <RecommendationDetailsLayout
      insideLook={insideLookComponent}
      details={detailsComponent}
      command={commandComponent}
      charts={chartsComponent}
      preferences={preferencesComponent}
    />
  );
};


export default Ec2Idle;
